import { render } from "./DeptBoardThumb.vue?vue&type=template&id=465c8f24"
import script from "./DeptBoardThumb.vue?vue&type=script&lang=js"
export * from "./DeptBoardThumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__